export default "__VITE_ASSET__19c93d57__"